var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dx-grid',{attrs:{"url":"smsdetails","baseUrl":"https://petitioncampaigns.azurewebsites.net","columns":_vm.columns,"title":_vm.title,"expandedOptions":{
            enabled: true,
            template: 'petition-sms-messages',
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }